/**
 * ReDelivery v1
 * El delivery mas coopado
 *
 * OpenAPI spec version: v1
 * Contact: redjar.redelivery@gmail.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export interface StoreTypePutBody { 
    cdStoreType?: number;
    dsName: string;
    dsDescription: string;
    isEnabled: boolean;
    dsNewImage?: string;
    itemImage?: Blob;
}